import {Box} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {NEGATIVE_COLOR, NEUTRAL_COLOR, POSITIVE_COLOR} from "../../insights/kit/insightsColors";
import {ElementChip} from "./base/ElementChip";

// The API's SurveyNpsClass values, coloured like the NPS split card; any other value is not shown.
const SURVEY_NPS_CLASSES = new Map<string, {labelKey: string, color: string}>([
    ['PROMOTER', {labelKey: 'Promoter', color: POSITIVE_COLOR}],
    ['PASSIVE', {labelKey: 'Passive', color: NEUTRAL_COLOR}],
    ['DETRACTOR', {labelKey: 'Detractor', color: NEGATIVE_COLOR}],
]);

export const surveyNpsClassLabelKey = (npsClass: string | null | undefined) => (
    npsClass ? SURVEY_NPS_CLASSES.get(npsClass)?.labelKey : undefined
);

interface SurveyNpsClassElementProps {
    /** The response's NPS class. Nothing is drawn without one: only an answer mapped to NPS gives it one. */
    npsClass: string | null | undefined;
}

export function SurveyNpsClassElement({npsClass}: SurveyNpsClassElementProps) {
    const {t} = useTranslation();

    const nps = npsClass ? SURVEY_NPS_CLASSES.get(npsClass) : undefined;
    if (!nps) return null;

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%"}}>
            <ElementChip
                text={`${t('NPS')}: ${t(nps.labelKey)}`}
                startIcon={
                    <Box
                        component="span"
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: nps.color,
                            flex: "0 0 auto",
                        }}
                    />
                }
            />
        </Box>
    );
}
